<template>
  <el-dialog
    class="deploy-contract-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="deployTit"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="合约名称" prop="ContractName">
        <el-input v-model="dataForm.ContractName"></el-input>
      </el-form-item>
      <el-form-item label="合约版本" prop="contractVersion">
        <el-input v-model="dataForm.contractVersion"></el-input>
      </el-form-item>
      <el-form-item label="虚拟机类型" prop="runtimeType">
        <el-select
          v-model="dataForm.runtimeType"
          placeholder="请选择"
          class="auto-width"
          @change="handleChange"
        >
          <el-option v-for="ele in options" :key="ele.value" :label="ele.label" :value="ele.value">
          </el-option>
        </el-select>
        <div class="tips">
          目前只有v2.1.0版本及以上的chainmaker支持docker_go，请确保您的链版本在V2.1.0以上，且开启docker-vm，详情可见开源文档
        </div>
      </el-form-item>
      <el-form-item label="合约文件" prop="compileSaveKey">
        <upload-files ref="contractFile" :show-validate="false"></upload-files>
      </el-form-item>
      <el-form-item v-show="showAbi" label="ABI文件" prop="evmAbiSaveKey">
        <upload-files ref="abi" :show-validate="false"></upload-files>
      </el-form-item>
      <el-form-item label="部署理由">
        <el-input
          v-model="dataForm.reason"
          type="textarea"
          placeholder="部署合约需其他组织同意，请输入部署理由（选填）"
          :resize="resize"
          :rows="3"
        ></el-input>
      </el-form-item>
      <el-form-item label="额外信息" prop="parameters">
        <operate-param ref="extractParam"></operate-param>
      </el-form-item>
      <el-form-item label="合约调用方法" prop="methods">
        <operate-param ref="methodParam" :param="invokeMethod"></operate-param>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="deployContract()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'DeployContract',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    let validateAbi = (rule, value, callback) => {
      if (this.dataForm.runtimeType === 5) {
        if (!value) {
          callback(new Error('请选择abi文件'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    let validateParam = (rule, value, callback) => {
      let con = this.$refs.extractParam.validateParam()
      if (con) {
        callback()
      } else {
        callback(new Error('请输入额外信息'))
      }
    }
    let validateMethods = (rule, value, callback) => {
      let condition = this.$refs.methodParam.validateParam()
      if (condition) {
        callback()
      } else {
        callback(new Error('请输入合约调用方法'))
      }
    }
    return {
      dialogVisible: false,
      disabled: false,
      deployTit: '部署合约',
      position: 'right',
      resize: 'none',
      editRule: {
        ContractName: [{ required: true, message: '请输入合约名称', trigger: 'blur' }],
        contractVersion: [{ required: true, message: '请输入合约版本', trigger: 'blur' }],
        runtimeType: [{ required: true, message: '请选择虚拟机类型', trigger: 'blur' }],
        compileSaveKey: [{ required: true, message: '请上传合约文件', trigger: 'blur' }],
        evmAbiSaveKey: [{ required: true, validator: validateAbi, trigger: 'blur' }],
        parameters: [{ validator: validateParam, trigger: 'change' }],
        methods: [{ validator: validateMethods, trigger: 'change' }]
      },
      dataForm: {
        chainId: '',
        ContractName: '',
        contractVersion: '',
        reason: '',
        parameters: [],
        methods: [],
        compileSaveKey: 'file', //文件
        runtimeType: 2,
        evmAbiSaveKey: ''
      },
      options: [],
      showAbi: false,
      invokeMethod: ['Method', 'key1,key2'],
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  methods: {
    getOptions() {
      //获取虚拟机类型
      this.$apis.chain.getRuntimeTypeList().then(res => {
        if (res.data) {
          let arr = res.data.items
          let newArr = arr.map(ele => {
            let item = {
              label: ele.RuntimeTypeName,
              value: ele.RuntimeTypeType
            }
            return item
          })
          this.options = newArr
        }
      })
    },
    handleCancel() {
      this.$refs.dataForm.clearValidate()
      this.$refs.extractParam.clearParam()
      this.$refs.methodParam.clearParam()
      this.$refs.abi.clear()
      this.$refs.contractFile.clear()
      this.disabled = false
      this.dataForm = {
        chainId: '',
        ContractName: '',
        contractVersion: '',
        reason: '',
        parameters: [],
        methods: [],
        compileSaveKey: 'file',
        evmAbiSaveKey: '',
        runtimeType: 2
      }
      this.showAbi = false
      this.options = []
      this.dialogVisible = false
    },
    handleOpen() {
      this.getOptions()
      this.dialogVisible = true
    },
    handleChange(val) {
      if (val === 5) {
        this.showAbi = true
      } else {
        this.$refs.abi.clear()
        this.showAbi = false
      }
    },
    //部署合约
    deployContract() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //获取form数据
          this.dataForm.chainId = this.$route.query.chainId
          //获取key,value数据
          this.dataForm.parameters = this.$refs.extractParam.getParam()
          let newMethod = this.$refs.methodParam.getParam()
          this.dataForm.methods = newMethod.map(elem => {
            let item = {
              methodKey: elem.value,
              methodName: elem.key
            }
            return item
          })
          //上传文件
          //判断是否上传abi文件
          if (this.dataForm.runtimeType === 5) {
            this.dataForm.evmAbiSaveKey = await this.uploadFile('abi', 'ABI')
          } else {
            this.dataForm.evmAbiSaveKey = ''
          }
          this.dataForm.compileSaveKey = await this.uploadFile('contractFile', '合约')
          this.$apis.chain
            .installContract(this.dataForm)
            .then(res => {
              if (res) {
                this.$message.success('合约部署成功')
                this.handleCancel()
                this.$emit('update:list')
              }
            })
            .catch(err => {
              this.disabled = false
            })
        } else {
          this.$message.warning('请完善信息')
          this.disabled = false
          return
        }
      })
    },
    uploadFile(refName, fileName) {
      return new Promise((resolve, reject) => {
        let file = this.$refs[refName].getFileRaw()
        if (file) {
          let formData = new FormData()
          formData.append('name', file.name)
          formData.append('file', file.raw)
          this.$apis.chain
            .uploadContract(formData)
            .then(res => {
              if (res.data) {
                resolve(res.data)
              }
            })
            .catch(err => {
              this.$message.error(`上传${fileName}文件失败`)
              return
            })
        } else {
          this.$message.error(`请上传${fileName}文件`)
          this.disabled = false
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('deploy-contract-dialog', (), ());
.deploy-contract-dialog.common-dialog {
  @include adaptation(());
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
